<template>
  <div>
    <navbar class="navbar" />
    <v-card outlined >
      <v-card-text>
        <v-row><v-col><h3>รายละเอียดสินค้า</h3></v-col></v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-text-field
              outlined
              hide-details="auto"
              dense
              autocomplete="off"
              label="ชื่อสินค้า"
              v-model="valueInput.productName"
              :rules="rule.productName"
              ref="productName"
            ></v-text-field>
          </v-col>
          <!-- <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              outlined
              hide-details="auto"
              dense
              label="รหัสสินค้า"
              v-model="valueInput.productCode"
              :rules="rule.productCode"
              ref="productCode"
              autocomplete="off"
            ></v-text-field>
          </v-col> -->
        </v-row>

        <v-row>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-select
              :items="itemsSelectCategoryProduct"
              item-text="name"
              item-value="_id"
              label="หมวดหมู่สินค้า"
              outlined
              hide-details="auto"
              dense
              autocomplete="off"
              v-model="valueInput.productCategory"
              :rules="rule.productCategory"
              ref="productCategoryID"
              return-object
            ></v-select>
          </v-col>

          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              label="แบรนด์สินค้า"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model="valueInput.productBrand"
              :rules="rule.productBrand"
              ref="productBrand"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="blobURL" sm="12" md="12" lg="12" cols="12">
            <v-img
              max-height="auto"
              max-width="250"
              :src="blobURL"
              style="display: block; margin: 0 auto"
            />
          </v-col>
          <v-col sm="12" md="12" lg="12" cols="12">
            <v-file-input
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="รูปภาพหน้าปก"
              outlined
              dense
              autocomplete="off"
              hide-details="auto"
              @change="previewFiles"
              ref="productImage"
            ></v-file-input>

          </v-col>
        </v-row>

        <v-row>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="น้ำหนัก (กรัม)"
              placeholder="0.00"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model.number="valueInput.productWeight"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productWeight"
              ref="productWeight"
            ></v-text-field>
          </v-col>

          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="ยาว (มม)"
              placeholder="0.00"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model.number="valueInput.productLong"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productLong"
              ref="productLong"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="กว้าง (มม)"
              placeholder="0.00"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model.number="valueInput.productWide"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productWide"
              ref="productWide"
            ></v-text-field>
          </v-col>

          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="สูง (มม)"
              placeholder="0.00"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model.number="valueInput.productHeight"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productHeight"
              ref="productHeight"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea
              label="รายละเอียดสินค้า (ย่อ)"
              auto-grow
              outlined
              hide-details="auto"
              dense
              autocomplete="off"
              v-model="valueInput.productSubDetail"
              :rules="rule.productSubDetail"
              ref="productSubDetail"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            ref="productDetail"
            style="height: 100%"
          >
            <vue-editor
              placeholder="รายละเอียดสินค้า"
              v-model="valueInput.productDetail"
              :rules="rule.productDetail"
            ></vue-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card style="margin: 30px 0 0 0">
      <v-card-text>
        <h3>คลังสินค้า</h3>

        <v-row>
          <v-divider style="margin: 10px 0"></v-divider>
        </v-row>

        <v-row>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="ต้นทุน (บาท)"
              placeholder="0.00"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model.number="valueInput.productCost"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productCost"
              ref="productCost"
            ></v-text-field>
          </v-col>

          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="ราคาต่อหน่วย (บาท)"
              placeholder="0.00"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model.number="valueInput.productPrice"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productPrice"
              ref="productPrice"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="จำนวนสินค้า (ชิ้น)"
              placeholder="0.00"
              hide-details="auto"
              dense
              autocomplete="off"
              outlined
              v-model.number="valueInput.productQTY"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productQTY"
              ref="productQTY"
            ></v-text-field>
          </v-col>

          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-text-field
              type="number"
              label="สินค้าคงคลังขั้นต่ำ (ชิ้น)"
              placeholder="0.00"
              hide-details="auto"
              dense
              outlined
              step=".1"
              v-model.number="valueInput.productMinimumInventory"
              @keypress="handleInputPhoneNumber"
              :rules="rule.productMinimumInventory"
              ref="productMinimumInventory"
              autocomplete="off"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row  class="mt-5 mb-5">
          <v-divider></v-divider>
        </v-row>

        <v-row  class="d-flex flex-row-reverse">
          <v-col sm="12" md="12" lg="3" cols="12">
            <v-btn
              color="success"
              depressed
              width="100%"
              class="pa-5"
              v-on:click="$route && $route.name === 'ProductCreate' ? handleInsertData() : handleEditData()"
            >
              <v-icon>mdi-content-save</v-icon>
              {{this.$route.name === 'ProductCreate' ? 'บันทึกรายการ' : 'แก้ไขรายการ'}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </div>

</template>

<script>
import script from '@/views/pages/products/product/form/form.script';

export default script;
</script>
